"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
var core = {
    Col: {
        "id": "Col",
        "name": "Col",
        "from": "Col",
    },
    Row: {
        "id": "Row",
        "name": "Row",
        "from": "Row",
    },
    Text: {
        "id": "Text",
        "name": "Text",
        "from": "Text",
    },
    Input: {
        "id": "Input",
        "name": "Input",
        "from": "Input",
    },
    Scroll: {
        "id": "Scroll",
        "name": "Scroll",
        "from": "Scroll",
    },
    Img: {
        "id": "Img",
        "name": "Img",
        "from": "Img",
    }
};
var ComponentBanks = (function () {
    function ComponentBanks() {
        this.core = core;
        this.banks = {};
        this.reactFrom = {
            Col: { reactComponent: index_1.Col },
            Row: { reactComponent: index_1.Row },
            Text: { reactComponent: index_1.Text },
            Scroll: { reactComponent: index_1.Scroll },
        };
    }
    ComponentBanks.prototype.addBanks = function (comps) {
        this.banks = __assign(__assign({}, this.banks), comps);
    };
    ComponentBanks.prototype.addCustomFrom = function (customComps) {
        this.reactFrom = __assign(__assign({}, this.reactFrom), customComps);
    };
    ComponentBanks.prototype.getReservedComponentIds = function () {
        var list = Object.keys(__assign(__assign({}, this.core), this.banks));
        return list;
    };
    return ComponentBanks;
}());
exports.default = new ComponentBanks();
//# sourceMappingURL=Banks.js.map